<!--
 * @Author: DY
 * @Date: 2024-11-25 10:23:15
 * @LastEditTime: 2024-11-29 16:53:09
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\views\sales\printTest\index.vue
-->
<template>
    <div class="printTest">
        <HeaderNav
            header-title="打印测试"
            left-icon-name="2"
            right-icon-name="3"
            :extr="{ leftCallBack: swiperright }"
        ></HeaderNav>
        <div style="height: 20px; text-align: center">
            <h2>LPAPI Web 2.0.20221010</h2>
        </div>

        <div style="height: 16px; text-align: center; margin-top:30px">
            <div style="margin: 15px;">
                <div style="display: inline-block">
                    打印机：
                </div>
                <select id="printerSelect">
                    <option>请选择打印机</option>
                </select>
            </div>
            <div>
                <h2>Android</h2>
            </div>
            <div style="margin: 10px;">
                <button @click="searchAndroid()">
                    搜索打印机(Android)
                </button>
                <button @click="printTextAndroid()">
                    测试打印(Android)
                </button>
            </div>
            <div style="margin: 10px;">
                <button @click="connectAndroid()">
                    连接(Android)
                </button>
                <button @click="disconnectAndroid()">
                    断开(Android)
                </button>
            </div>
            <div>
                <h2>IOS</h2>
            </div>
            <div style="margin: 10px;">
                <button @click="searchIOS()">
                    搜索打印机(IOS)
                </button>
                <button @click="printTextIOS()">
                    测试打印(IOS)
                </button>
            </div>
            <div style="margin: 10px;">
                <button @click="connectIOS()">
                    连接(IOS)
                </button>
                <button @click="disconnectIOS()">
                    断开(IOS)
                </button>
            </div>
            <div style="margin: 10px;">
                <button @click="drawRectangleIOS()">
                    drawRectangleIOS
                </button>
                <button @click="drawTextIOS()">
                    drawTextIOS
                </button>
            </div>
            <div style="margin: 10px;">
                <button @click="drawLineIOS()">
                    drawLineIOS
                </button>
                <button @click="draw2DQRCodeIOS()">
                    draw2DQRCodeIOS
                </button>
            </div>
            <div>
                <br>
            </div>
            <div style="margin: 10px;">
                <button @click="openPrinterPage()">
                    打开原生打印预览页面
                </button>
            </div>
            <div>
                <button @click="openPrinterManagePage()">
                    打开原生搜索打印机页面
                </button>
            </div>
            <div>
                <br>
            </div>
            <div style="margin: 10px;">
                <button @click="getStatusBarHeight()">
                    获取状态栏高度
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { LPAPI } from '@/assets/js/print/LPAPI-0.4.20181022.js';

export default {
    name: 'print-test',
    components: {
        HeaderNav,
    },
    data() {
        return {
            lpapi: null,
            currentConnectPrinter: '',
            printerList: [],
        };
    },
    watch: {},
    created() {
        this.lpapi = new LPAPI();
        // 转发原生回调函数
        window.callback_DzLPAPI_scanPrinters = this.callback_DzLPAPI_scanPrinters;
    },
    mounted() {
        /**
         * 创建打印机对象，并更新打印机列表。
         */
        // this.updatePrintersSelect();
    },
    computed: {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        /**
         * 搜索打印机（IOS）
         */
        searchIOS() {
            this.$toast('开始获取打印机列表');
            const callMobileData = {};
            this.$callMobile('DzLPAPI', 'scanPrinters', callMobileData);
        },
        // 原生调js回传打印机列表
        callback_DzLPAPI_scanPrinters(printerNames) {
            this.$toast('获取打印机列表回调' + printerNames);
            const printerSelect = document.getElementById('printerSelect');
            if (!printerSelect) {
                return;
            }
            printerSelect.innerHTML = '';

            if (!printerNames) {
                printerSelect.options.add(new Option('未检测到打印机', ''));
                return;
            }
            const printerList = printerNames.split(',');
            for (let i = 0; i < printerList.length; i++) {
                printerSelect.options.add(new Option(printerList[i], printerList[i]));
            }
        },
        /**
         * 连接打印机IOS
         */
        connectIOS() {
            const callMobileData = { printerName: 'DT-353-C40993241' };
            this.$callMobile('DzLPAPI', 'openPrinter', callMobileData);
            this.$toast('调用连接打印机');
        },
        /**
         * 断开打印机（IOS）
         */
        disconnectIOS() {
            const callMobileData = { };
            this.$callMobile('DzLPAPI', 'closePrinter', callMobileData);
            this.$toast('调用断开打印机');
        },
        /**
         *打印文本信息（IOS）
        */
        printTextIOS() {
            // 打开打印机
            // 开始打印操作。

            // this.lpapi.startJob(70, 40, 90);
            let callMobileData = { width: 70, height: 40, orientation: 90 };
            this.$callMobile('DzLPAPI', 'startDraw', callMobileData);

            // this.lpapi.drawRectangle(1, 2, 66, 36, 0.3);
            callMobileData = { x: 1, y: 2, width: 66, height: 36, lineWidth: 0.3, isFilled: 0 };
            this.$callMobile('DzLPAPI', 'drawRectangleWithX', callMobileData);

            // this.lpapi.drawText('仓库名称', 2, 3.5, 16, 7, 3, 0);
            callMobileData = { text: '仓库名称', x: 2, y: 3.5, width: 16, height: 7, fontHeight: 3 };
            this.$callMobile('DzLPAPI', 'drawText', callMobileData);

            // this.lpapi.drawText('鳞片石墨成品库（负目库）', 17, 3.5, 27, 7, 4, 0);
            callMobileData = { text: '鳞片石墨成品库（负目库）', x: 17, y: 3.5, width: 27, height: 7, fontHeight: 4 };
            this.$callMobile('DzLPAPI', 'drawText', callMobileData);

            // this.lpapi.drawLine(1, 9, 45, 9, 0.3);
            callMobileData = { x: 1, y: 9, width: 45, height: 0.3 };
            this.$callMobile('DzLPAPI', 'drawLine', callMobileData);

            // this.lpapi.drawText('库位编号', 2, 10.5, 16, 7, 3, 0);
            callMobileData = { text: '库位编号', x: 2, y: 10.5, width: 16, height: 7, fontHeight: 3 };
            this.$callMobile('DzLPAPI', 'drawText', callMobileData);

            // this.lpapi.drawLine(1, 16, 45, 16, 0.3);
            callMobileData = { x: 1, y: 16, width: 45, height: 0.3 };
            this.$callMobile('DzLPAPI', 'drawLine', callMobileData);

            // this.lpapi.drawText('库位名称', 2, 17.5, 16, 7, 3, 0);
            callMobileData = { text: '库位名称', x: 2, y: 17.5, width: 16, height: 7, fontHeight: 3 };
            this.$callMobile('DzLPAPI', 'drawText', callMobileData);

            // this.lpapi.drawLine(1, 23, 45, 23, 0.3);
            callMobileData = { x: 1, y: 23, width: 45, height: 0.3 };
            this.$callMobile('DzLPAPI', 'drawLine', callMobileData);

            // this.lpapi.drawText('物料代码', 2, 24.5, 16, 7, 3, 0);
            callMobileData = { text: '物料代码', x: 2, y: 24.5, width: 16, height: 7, fontHeight: 3 };
            this.$callMobile('DzLPAPI', 'drawText', callMobileData);

            // this.lpapi.drawLine(1, 30, 45, 30, 0.3);
            callMobileData = { x: 1, y: 30, width: 45, height: 0.3 };
            this.$callMobile('DzLPAPI', 'drawLine', callMobileData);

            // this.lpapi.drawText('短描述', 2, 32, 16, 7, 3, 0);
            callMobileData = { text: '短描述', x: 2, y: 32, width: 16, height: 7, fontHeight: 3 };
            this.$callMobile('DzLPAPI', 'drawText', callMobileData);

            // this.lpapi.drawLine(15, 2, 15, 38, 0.3);
            callMobileData = { x: 15, y: 2, width: 0.3, height: 38 };
            this.$callMobile('DzLPAPI', 'drawLine', callMobileData);

            // this.lpapi.drawLine(45, 2, 45, 38, 0.3);
            callMobileData = { x: 45, y: 2, width: 0.3, height: 38 };
            this.$callMobile('DzLPAPI', 'drawLine', callMobileData);

            // this.lpapi.draw2DQRCode('上海道臻信息技术有限公司', 46.5, 10, 18, 18);
            callMobileData = { text: '上海道臻信息技术有限公司', x: 46.5, y: 10, width: 18 };
            this.$callMobile('DzLPAPI', 'drawQRCode', callMobileData);


            callMobileData = {};
            this.$callMobile('DzLPAPI', 'endDraw', callMobileData);

            // this.lpapi.commitJob();
            callMobileData = {};
            this.$callMobile('DzLPAPI', 'print', callMobileData);

            this.$toast('调用打印');
        },
        drawRectangleIOS() {
            let callMobileData = { width: 70, height: 40, orientation: 90 };
            this.$callMobile('DzLPAPI', 'startDraw', callMobileData);

            // this.lpapi.drawRectangle(1, 2, 66, 36, 0.3);
            callMobileData = { x: 1, y: 2, width: 66, height: 36, lineWidth: 0.3, isFilled: 0 };
            this.$callMobile('DzLPAPI', 'drawRectangleWithX', callMobileData);

            callMobileData = {};
            this.$callMobile('DzLPAPI', 'endDraw', callMobileData);

            // this.lpapi.commitJob();
            callMobileData = {};
            this.$callMobile('DzLPAPI', 'print', callMobileData);

            this.$toast('调用打印:drawRectangle');
        },
        drawTextIOS() {
            let callMobileData = { width: 70, height: 40, orientation: 90 };
            this.$callMobile('DzLPAPI', 'startDraw', callMobileData);

            // this.lpapi.drawText('仓库名称', 2, 3.5, 16, 7, 3, 0);
            callMobileData = { text: '仓库名称', x: 2, y: 3.5, width: 16, height: 7, fontHeight: 3 };
            this.$callMobile('DzLPAPI', 'drawText', callMobileData);

            callMobileData = {};
            this.$callMobile('DzLPAPI', 'endDraw', callMobileData);

            // this.lpapi.commitJob();
            callMobileData = {};
            this.$callMobile('DzLPAPI', 'print', callMobileData);

            this.$toast('调用打印:drawTextIOS');
        },
        drawLineIOS() {
            let callMobileData = { width: 70, height: 40, orientation: 90 };
            this.$callMobile('DzLPAPI', 'startDraw', callMobileData);

            // this.lpapi.drawLine(1, 9, 45, 9, 0.3);
            callMobileData = { x: 1, y: 9, width: 45, height: 0.3 };
            this.$callMobile('DzLPAPI', 'drawLine', callMobileData);

            callMobileData = {};
            this.$callMobile('DzLPAPI', 'endDraw', callMobileData);

            // this.lpapi.commitJob();
            callMobileData = {};
            this.$callMobile('DzLPAPI', 'print', callMobileData);

            this.$toast('调用打印:drawLineIOS');
        },
        draw2DQRCodeIOS() {
            let callMobileData = { width: 70, height: 40, orientation: 90 };
            this.$callMobile('DzLPAPI', 'startDraw', callMobileData);

            // this.lpapi.draw2DQRCode('上海道臻信息技术有限公司', 46.5, 10, 18, 18);
            callMobileData = { text: '上海道臻信息技术有限公司', x: 46.5, y: 10, width: 18 };
            this.$callMobile('DzLPAPI', 'drawQRCode', callMobileData);

            callMobileData = {};
            this.$callMobile('DzLPAPI', 'endDraw', callMobileData);

            // this.lpapi.commitJob();
            callMobileData = {};
            this.$callMobile('DzLPAPI', 'print', callMobileData);

            this.$toast('调用打印:draw2DQRCodeIOS');
        },
        /**
         * 搜索打印机（Android）
         */
        searchAndroid() {
            const printerSelect = document.getElementById('printerSelect');
            if (!printerSelect) {
                return;
            }

            printerSelect.innerHTML = '';
            const printerNames = this.lpapi.getAllPrinters();

            if (!printerNames) {
                printerSelect.options.add(new Option('未检测到打印机', ''));
                return;
            }

            const printerList = printerNames.split(',');
            for (let i = 0; i < printerList.length; i++) {
                printerSelect.options.add(new Option(printerList[i], printerList[i]));
            }
        },
        /**
         * 连接打印机（Android）
         */
        connectAndroid() {
            const printerName = document.getElementById('printerSelect').value;
            if (!printerName) {
                return false;
            }
            return this.lpapi.openPrinterSync(printerName);
        },
        /**
         * 断开打印机（Android）
         */
        disconnectAndroid() {
            return this.lpapi.closePrinter();
        },
        /**
         *打印文本信息（Android）
        */
        printTextAndroid() {
            // 开始打印操作。
            this.lpapi.startJob(70, 40, 90);
            this.lpapi.drawRectangle(1, 2, 66, 36, 0.3);
            this.lpapi.drawText('仓库名称', 2, 3.5, 16, 7, 3, 0);
            this.lpapi.drawText('鳞片石墨成品库（负目库）', 17, 3.5, 27, 7, 4, 0);
            this.lpapi.drawLine(1, 9, 45, 9, 0.3);
            this.lpapi.drawText('库位编号', 2, 10.5, 16, 7, 3, 0);
            this.lpapi.drawLine(1, 16, 45, 16, 0.3);
            this.lpapi.drawText('库位名称', 2, 17.5, 16, 7, 3, 0);
            this.lpapi.drawLine(1, 23, 45, 23, 0.3);
            this.lpapi.drawText('物料代码', 2, 24.5, 16, 7, 3, 0);
            this.lpapi.drawLine(1, 30, 45, 30, 0.3);
            this.lpapi.drawText('短描述', 2, 32, 16, 7, 3, 0);
            this.lpapi.drawLine(15, 2, 15, 38, 0.3);
            this.lpapi.drawLine(45, 2, 45, 38, 0.3);
            this.lpapi.draw2DQRCode('上海道臻信息技术有限公司', 46.5, 10, 18, 18);
            this.lpapi.commitJob();
        },
        /**
         * 打开原生打印预览页面
         */
        openPrinterPage() {
            this.$toast('打开原生打印预览页面');
            const callMobileData = {};
            this.$callMobile('JYLPAPINative', 'openPrinterPage', callMobileData);
        },
        /**
         * 打开原生搜索打印机页面
         */
        openPrinterManagePage() {
            this.$toast('打开原生搜索打印机页面');
            const callMobileData = {};
            this.$callMobile('JYLPAPINative', 'scanPrinters', callMobileData);
        },
        /**
         * 获取状态栏高度
         */
        getStatusBarHeight() {
            const jy_navbarHeight = localStorage.getItem('jy_navbarHeight');
            const statusBarHeight = localStorage.getItem('statusBarHeight');
            this.$toast(`jy_navbarHeight:${jy_navbarHeight},statusBarHeight:${statusBarHeight}`);
        },
    },
    updated() { },
    destroyed() { },
};
</script>

<style lang="stylus" scoped></style>
